import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IOebsConfig, LGEDataService } from '../../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromOebsConfig from './state/oebs-config.selectors';
import * as OebsConfigAction from './state/oebs-config.actions';
import * as lgeApp from '../../../app/state/app.actions';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription, skipWhile } from 'rxjs';
import { ConfirmModalComponent } from 'src/commons/modals';

@Component({
    selector: 'oebs-config-screen',
    templateUrl: 'oebs-config.component.html',
    styleUrls: ['oebs-config.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OebsConfigExtScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<IOebsConfig | null>;
    stateDataSubscription: Subscription;
    stateData: IOebsConfig | null;

    @Input() title: string;
    @Input() message: string;

    public confirm: any;
    isValid: boolean = false;
    oebsInfo: FormGroup;
    accDistList = [
        { name: 'Company', value: 'COMPANY' },
        { name: 'Org', value: 'ORG' },
        { name: 'Account', value: 'ACCT' },
        { name: 'Project/Task', value: 'PROJ_TASK_PLUS' },
        { name: 'Exp Type', value: 'EXP_TYPE' },
        { name: 'Exp Org', value: 'EXP_ORG' }]

    accDistObj = {
        'ProjectGroup': [''],
        'TaskGroup': [''],
        'CompanyGroup': [''],
        'ProductGroup': [''],
        'OrganizationGroup': [''],
        'ExpenditureOrgGroup': [''],
        'AccountGroup': [''],
        'IntercompanyGroup': [''],
        'ExpenditureTypeGroup': [''],
        'LocationGroup': [''],
        'ReturnType': ''
    }

    constructor(
        private store: Store<fromOebsConfig.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService,
        private dialog: MatDialog,
    ) {
        this.selectState();
        this.createForms();
    }

    ngOnInit() {
        this.startSubscriptions();
    }

    createForms(): void {
        this.oebsInfo = this.fb.group({
            'accDist': ['']
            // 'EmpId': ['', Validators.pattern(new RegExp(/^[enEN][0-9]{6}$/))]
        });

        this.oebsInfo.get('accDist').valueChanges.subscribe((value: string) => {
            if (value == '' || value == undefined || value == null) {
                this.isValid = false;
            } else {
                this.isValid = true;
            }
        });

    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '455px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }

    GetAccDistInfo() {
        let selectedAccDist = this.oebsInfo.get('accDist').value;
        this.showConfirm('Are you sure you want to save AccDist Info?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                let tempAccDistObj = Object.assign({}, this.accDistObj);
                switch (selectedAccDist) {
                    case 'ORG':
                        tempAccDistObj.CompanyGroup = ['0100,0110'];
                        break;
                    case 'PROJ_TASK_PLUS':
                        tempAccDistObj.OrganizationGroup = ['008925, 018925, 001035, 011035, 008850, 018850'];
                        tempAccDistObj.AccountGroup = ['426101, 426120'];
                        break;
                }
                tempAccDistObj.ReturnType = selectedAccDist;
                // console.log(tempAccDistObj);

                let jsonData = JSON.stringify(tempAccDistObj);
                // console.log(jsonData);
                this.ams.showLoader('Saving...');
                this._dataService.GetAccDistInfo(jsonData)
                    .subscribe({
                        next: data => {
                            this.oebsInfo.get('accDist').setValue('');
                            // console.log(data);
                            this.ams.closeDialog();
                            this.ams.showAlert('Success!', 'Successfully Saved!');
                        },
                        error: error => {
                            this.oebsInfo.get('accDist').setValue('');
                            // console.log(error);
                            this.ams.closeDialog();
                            this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                        }
                    });
            }
        });
    }

    DeleteAccDistInfo() {
        this.showConfirm('Are you sure you want to delete AccDist Info?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.ams.showLoader('Deleting...');
                let selectedAccDist = this.oebsInfo.get('accDist').value;
                // console.log(this.oebsInfo.value);
                if (selectedAccDist !== 'PROJ_TASK_PLUS') {
                    this._dataService.DeleteAccDistInfoByName(selectedAccDist)
                        .subscribe({
                            next: data => {
                                this.oebsInfo.get('accDist').setValue('');
                                // console.log(data);
                                this.ams.closeDialog();
                                this.ams.showAlert('Success!', 'Successfully Deleted!');
                            },
                            error: error => {
                                this.oebsInfo.get('accDist').setValue('');
                                // console.log(error);
                                this.ams.closeDialog();
                                this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                            }
                        });
                } else {
                    this._dataService.DeleteProjectTaskInfo()
                        .subscribe({
                            next: data => {
                                this.oebsInfo.get('accDist').setValue('');
                                // console.log(data);
                                this.ams.closeDialog();
                                this.ams.showAlert('Success!', 'Successfully Deleted!');
                            },
                            error: error => {
                                this.oebsInfo.get('accDist').setValue('');
                                // console.log(error);
                                this.ams.closeDialog();
                                this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                            }
                        });
                }
            }
        });
    }

    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromOebsConfig.getOebsConfigScreenPending);
        this.stateData$ = this.store.select(fromOebsConfig.getOebsConfigState);
        this.error$ = this.store.select(fromOebsConfig.getOebsConfigScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new OebsConfigAction.OebsConfigScreenErrorReset());
        });
    }

    // Create reactive forms

    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }

}


// private projectTaskObj = {
//     'ProjectGroup': {
//         'Project': ['']
//     },
//     'TaskGroup': {
//         'Task': ['']
//     },
//     'CompanyGroup': {
//         'Company': ['']
//     },
//     'ProductGroup': {
//         'Product': ['']
//     },
//     'OrganizationGroup': {
//         'Organization': ['008925, 018925, 001035, 011035, 008850, 018850']
//     },
//     'ExpenditureOrgGroup': {
//         'ExpenditureOrg': ['']
//     },
//     'AccountGroup': {
//         'Account': ['426101, 426120']
//     },
//     'IntercompanyGroup': {
//         'Intercompany': ['']
//     },
//     'ExpenditureTypeGroup': {
//         'ExpenditureType': ['']
//     },
//     'LocationGroup': {
//         'Location': ['']
//     },
//     'ReturnType': 'PROJ_TASK_PLUS'
// }
// private accDistObj = {
//     'ProjectGroup': {
//         'Project': ['']
//     },
//     'TaskGroup': {
//         'Task': ['']
//     },
//     'CompanyGroup': {
//         'Company': ['']
//     },
//     'ProductGroup': {
//         'Product': ['']
//     },
//     'OrganizationGroup': {
//         'Organization': ['']
//     },
//     'ExpenditureOrgGroup': {
//         'ExpenditureOrg': ['']
//     },
//     'AccountGroup': {
//         'Account': ['']
//     },
//     'IntercompanyGroup': {
//         'Intercompany': ['']
//     },
//     'ExpenditureTypeGroup': {
//         'ExpenditureType': ['']
//     },
//     'LocationGroup': {
//         'Location': ['']
//     },
//     'ReturnType': ''
// }